export default {
  DARK: {
    heading: p => p.accentWhite,
    headingLine: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    line: p => p.primaryLight
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    headingLine: p => p.primaryLight,
    paragraph: p => p.tertiaryNormal,
    background: p => `${p.tertiaryLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    line: p => p.primaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    headingLine: p => p.primaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `${p.tertiaryExtraLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    line: p => p.primaryLight
  }
}
